const SESSION_KEY = 'signvoice:sessionId';

/** Returns a stable UUIDv4 stored in localStorage (generates on first call). */
export function getSessionId() {
  if (typeof localStorage === 'undefined') return 'anon';
  let id = localStorage.getItem(SESSION_KEY);
  if (!id) {
    id =
      typeof crypto !== 'undefined' && crypto.randomUUID
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(SESSION_KEY, id);
  }
  return id;
}

/** First N chars of the session id for display in the avatar panel. */
export const shortSessionId = (sid, n = 8) => (sid || '').slice(0, n);

export function resetSessionId() {
  if (typeof localStorage === 'undefined') return;
  localStorage.removeItem(SESSION_KEY);
}
